import React from 'react';

class Down extends React.Component {
    render() {
        return (
            <div className="container">
                <div className="other">
                    <img src={require("../images/error.svg")} alt="Error" />
                    <h2>Yikes!</h2>
                    <p>We're experiencing technical difficulties at the moment, please try again later.</p>
                </div>
            </div>
        )
    }
}

export default Down;